import { render, staticRenderFns } from "./OAuthLoginPanel.vue?vue&type=template&id=672dc024&scoped=true"
import script from "./OAuthLoginPanel.vue?vue&type=script&lang=ts"
export * from "./OAuthLoginPanel.vue?vue&type=script&lang=ts"
import style0 from "./OAuthLoginPanel.vue?vue&type=style&index=0&id=672dc024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672dc024",
  null
  
)

export default component.exports